module.exports = __webpack_public_path__ + "static/img/5areaA_2.a08eb5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/5areaA_2.png
// module id = 823
// module chunks = 1